<template>
  <div class="about_page">
    <div
      class="atp_1 about_mo"
      v-if="imageList"
      :style="{ backgroundImage: 'url(' + imageList[0] + ')' }"
    >
      <div class="halababy_about_2">
        <p class="atp_1_1" v-html="testList[0]"></p>
        <p class="atp_1_2" v-html="testList[1]"></p>
        <ul>
          <li><i></i>{{ testList[2] }}</li>
          <li><i></i>{{ testList[3] }}</li>
          <li><i></i>{{ testList[4] }}</li>
        </ul>
      </div>
    </div>
    <div class="atp_2">
      <div class="atp_2_1">
        <p>{{ testList[18] }}</p>
        <div></div>
      </div>
      <div class="atp_2_2">
        <div class="atp_2_2d2">
          <!-- <p>
            {{ siteNum5 }}
          </p>
          <p>{{ siteNum6 }}</p>
          <p>
            {{ siteNum7 }}
          </p> -->
          <!-- <div class="i_4_abuout">ABOUT US</div>
          <div class="i_4_lan"></div> -->
          <!-- <div class="i_4_jj">{{ siteNum36 }}</div> -->
          <div class="atp_2_2d1">
            <!-- <img width="100%" v-if="imageList" :src="imageList[1]" /> -->
          <div
            class="atp_2_2d1i"
            
          ></div>
          <div
            class="atp_2_2d12" 
          ></div>
          </div>
          <div class="i_4_jjcon">
            {{ testList[22] }}
          </div>
        </div>
      </div>
    </div>
    <div class="atp_3">
      <div class="atp_3_1">
        <p>{{ testList[19] }}</p>
        <div></div>
      </div>
      <div class="atp_3_2">
        <div class="atp_3_21">
          <div class="atp_3_21d">
            <img class="atp_3_21d1" v-if="imageList" :src="imageList[3]" />
            <p class="atp_3_21d2">{{ testList[5] }}</p>
            <p class="atp_3_21d3">
              {{ testList[8] }}
            </p>
          </div>
          <div class="atp_3_21d">
            <img class="atp_3_21d1" v-if="imageList" :src="imageList[4]" />
            <p class="atp_3_21d2">{{ testList[6] }}</p>
            <p class="atp_3_21d3">
              {{ testList[9] }}
            </p>
          </div>
          <div class="atp_3_21d">
            <img class="atp_3_21d1" v-if="imageList" :src="imageList[5]" />
            <p class="atp_3_21d2">{{ testList[7] }}</p>
            <p class="atp_3_21d3">{{ testList[10] }}</p>
          </div>
        </div>
        <div class="atp_3_22">
          <div
            class="atp_3_221"
             v-if="imageList"
            :style="{
              background: 'url(' + imageList[6] + ') no-repeat center center',
            }"
          ></div>
          <div class="atp_3_222">
            <p class="atp_3_2221">{{ testList[11] }}</p>
            <div class="atp_3_2222"></div>
            <p class="atp_3_2223" v-html="testList[12]">
              
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="atp_4">
      <div class="atp_4_1">
        <p>{{ testList[20] }}</p>
        <div></div>
      </div>
      <div class="atp_4_2">
        <div v-for="(item,index) in coopList"  :key="item.id" class="atp_4_2d" :style="index > 3?'margin-top: 30px':''">
          <div class="halababy_about_1">
            <img class="atp_4_2dd" :src="item.imgUrl" />
          </div>
        </div>
      </div>
    </div>
    <div class="atp_5">
      <div class="atp_5_1">
        <p>{{ testList[21] }}</p>
        <div></div>
      </div>
      <div class="atp_5_2">
        <!-- <p class="atp_5_21">{{ siteNum16 }}</p> -->
        <div class="atp_5_22">
          <div class="atp_5_221">
            <!-- <p class="atp_5_2211">{{ siteNum17 }}</p> -->
            <p class="atp_5_2212">{{ testList[13] }}</p>
            <div class="atp_5_2213">
              <div>
                <img v-if="imageList"  :src="imageList[7]" />
                <p>{{ testList[16] }}</p>
              </div>
              <div>
                <img v-if="imageList" :src="imageList[8]" />
                <p>{{ testList[17] }}</p>
              </div>
            </div>
          </div>
          <div class="atp_5_222"></div>
          <div class="atp_5_223">
            <!-- <p class="atp_5_2231">{{ siteNum19 }}</p> -->
            <img v-if="imageList" :src="imageList[9]" />
            <p class="atp_5_2233">{{ testList[14] }}</p>
            <p class="atp_5_2234">{{ testList[15] }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about_page",
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.changeLang(type);
    },
  },
  mounted: function () {
    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.changeLang('zh')
    }else{
      this.changeLang('en')
    }
    // this.changeLang(this.$i18n.locale);
    this.getImg();
    this.getCoop();
  },
  methods: {
    tolooplay() {
      this.$router.push({
        path: "/looplay",
      });
    },
    tohalababy() {
      this.$router.push({
        path: "/halababy",
      });
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 4 }).then((res) => {
        let arr = new Array();
        for(var index in res.data){
          arr.push(this.$ip + res.data[index]["imgUrl"]);
        }
        this.imageList = arr;
      });
    },
    //获取合作伙伴图片
    getCoop() {
      this.$post("/halababy/loofox/cooplist", { pageNum: 4 }).then((res) => {
        let arr = new Array();
        res.data.forEach((item) => {
          let tem = {
            id: item.id,
            imgUrl: this.$ip + item.imgUrl,
          };
          arr.push(tem);
        });
        this.coopList = arr;
      });
    },
    //修改语言
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 4 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
  },
  data() {
    return {
      coopList: this.coopList,
      imageList: this.imageList,
      testList:[],
    };
  },
};
</script>

<style>
.about_page {
  width: 100%;
}
.about_mo {
  margin: 0 auto 80px auto;
}
.atp_1 {
  width: 100%;
  height: 600px;
  position: relative;
}
.halababy_about_2{
  max-width: 1200px;
  padding-top: 120px;
  margin: auto;
}
.atp_1_1 {
  /* position: absolute;
  top: 120px;
  left: 360px; */
  font-size: 64px;
  font-family: sucaijishikufangti;
  font-weight: 400;
  color: #ffffff;
  text-shadow: 0px 4px 6px rgba(14, 176, 223, 0.2);
  text-align: left;
}
.atp_1_2 {
  /* position: absolute;
  top: 207px;
  left: 360px; */
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  text-align: left;
}
.atp_1 ul {
  /* position: absolute;
  top: 307px;
  left: 390px; */
  padding: 0;
  list-style: none;
}
.atp_1 ul li {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: left;
  margin-top: 20px;
}
.atp_1 ul li i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: white;
  display: inline-block;
  margin-right: 50px;
}
.atp_2,
.atp_3,
.atp_4,
.atp_5,
.atp_6 {
  width: 1200px;
  margin: 0 auto 80px auto;
  display: flex;
}
.atp_2_1,
.atp_3_1,
.atp_4_1,
.atp_5_1 {
  width: 15%;
  overflow: hidden;
}
.atp_2_1 p,
.atp_3_1 p,
.atp_4_1 p,
.atp_5_1 p {
  display: inline-block;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
  border-bottom: 6px solid rgba(10, 177, 255, 1);
}
/* .atp_2_1 div,
.atp_3_1 div,
.atp_4_1 div,
.atp_5_1 div {
  width: 40%;
  height: 6px;
  margin: 20px auto 0 auto;
  background-color: rgba(10, 177, 255, 1);
} */
.atp_2_2,
.atp_3_2,
.atp_4_2,
.atp_5_2,.atp_6_2 {
  width: 80%;
  margin-left: 5%;
}
.app_1{
  display: flex;
  justify-content: space-between;
}
.atp_2_2d1 {
  display: flex;
  justify-content: space-between;
}
.atp_2_2d1 div {
  width: 448px;
  height: 252px;
}
/* .atp_2_2d1 div:hover {
  background-size: 200% !important;
} */
.atp_2_2d2 {
  /* text-align: left; */
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  /* margin-top: 35px; */
  line-height: 48px;
}
.atp_3_21 {
  display: flex;
  justify-content: space-around;
}
.atp_3_21 .atp_3_21d {
  width: 20%;
}
.atp_3_21d2 {
  margin-top: 30px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
}
.atp_3_21d3 {
  margin-top: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
}
.atp_3_22 {
  margin-top: 50px;
  width: 987px;
  height: 377px;
  background-image: url("../assets/about/about6.png");
  display: flex;
  align-items: center;
}
.atp_3_221 {
  margin-left: 10%;
  width: 274px;
  height: 253px;
  background-image: url("../assets/about/about5.png");
}
.atp_3_222 {
  margin-left: 6%;
  width: 50%;
  height: 60%;
  text-align: left;
}
.atp_3_2221 {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
}
.atp_3_2222 {
  width: 50px;
  height: 6px;
  background-color: rgba(255, 150, 26, 1);
  margin-top: 3%;
  margin-bottom: 7%;
}
.atp_3_2223 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
}
.atp_4_2d {
  width: 240px;
  height: 88px;
  float: left;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-content: center;
}
/* .atp_4_2dd {
  width: 208px;
  height: 88px;
  margin: auto;
  display: flex;
  align-items: center;
} */
.atp_4_2d:hover {
  background: #fffffe;
  box-shadow: 0px 0px 24px 0px rgba(84, 92, 96, 0.12);
}
.atp_4_2 div img {
  margin: auto;
}
/* .atp_5_21 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 48px;
  text-align: left;
} */
.atp_5_22 {
  display: flex;
  direction: column;
  /* margin-top: 40px; */
  width: 100%;
  height: 300px;
  align-items: center;
}
.atp_5_221 {
  width: 45%;
  height: 100%;
}
.atp_5_222 {
  width: 0px;
  height: 80%;
  border: 1px dashed #a2a2a2;
  margin-left: 5%;
}
.atp_5_223 {
  width: 35%;
  height: 100%;
  margin-left: 10%;
}
/* .atp_5_2211 {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  line-height: 48px;
  text-align: left;
} */
.atp_5_2212 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 48px;
  /* text-align: left; */
}
.atp_5_2213 {
  display: flex;
  font-size: 24px;
  font-family: Microsoft YaHei;
  justify-content: space-between;
  font-weight: 400;
  color: #696969;
}
.atp_5_2213 p{
  margin: 0;
}
/* .atp_5_2231 {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  line-height: 48px;
  margin-bottom: 10px;
} */
.atp_5_2233 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ff8314;
  line-height: 48px;
  margin: 10px auto 10px auto;
}
.atp_5_2234 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #898989;
  line-height: 48px;
}
.app_0{
  height: 362px;
}
.app_2{
  width: 48%;
}
.app_3{
  width: 100%;
  height: 258px;
  background-repeat: no-repeat;
  background-size: contain;
}
.app_4{
  width: 100%;
  height: 258px;
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../assets/cp1.png");
}
.app_5{
  width: 100%;
  height: 100%;
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../assets/cp4.png");
}
.app_6{
  width: 100%;
  height: 112px;
  position: relative;
}

.i_5 {
  width: 1200px;
  margin: 79px auto 20px auto;
}
.i_5_lapp {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: space-between;
}
.i_5_hala {
  width: 599px;
  height: 459px;
}
/* .app_2:hover {
  background: url("../assets/index/in2.png");
} */
.i_5_hala_s {
  width: 576px;
  height: 324px;
  margin: auto;
  position: relative;
}
.i_5_hala1_s {
  width: 576px;
  height: 324px;
  background-image: url("../assets/cp5.png");
  margin: auto;
  position: relative;
}
.i_5_hala_s1 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.i_5_hala_s2 {
  position: absolute;
  z-index: 1;
  top: 43px;
  left: 30px;
}

.i_5_hala_s3 {
  position: absolute;
  z-index: 1;
  top: 46px;
  left: 186px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fffefe;
}
.i_5_hala_s4 {
  position: absolute;
  z-index: 1;
  top: 85px;
  left: 30px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
}
.app_7 {
  position: absolute;
  z-index: 1;
  top: 173px;
  left: 30px;
  padding: 5px 20px;
  background-color: #ffffff;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0ab1ff;
}
.i_5_hala_sx1 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 30px;
}
.i_5_hala_sx2 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 56px;
}
.i_5_hala_sx3 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 82px;
}
.i_5_hala_sx4 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 108px;
}
.i_5_hala_sx5 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 134px;
}
.app_6:hover{
  box-shadow: 0 0 15px rgb(145, 143, 143);
}
.app_6 img {
  position: absolute;
  top: 11px;
  left: 11px;
}
.app_6 p {
  position: absolute;
  top: 26px;
  left: 114px;
  width: 330px;
  height: 56px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 36px;
  text-align: left;
}

.i_4_abuout {
  font-size: 44px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #c0c0c0;
}
.i_4_lan {
  margin: 23px auto 0 auto;
  width: 88px;
  height: 6px;
  background-color: rgba(10, 177, 255, 1);
}

.i_4_jj {
  margin: 0 auto 34px auto;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.i_4_jjcon {
  width: 960px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #696969;
  line-height: 44px;
  margin: 30px auto auto auto;
  text-align: left;
}
.halababy_about_1{
  widows: 220px;
  height: 80;
  display: flex;
  justify-content: center;
  align-content: center;
}
.halababy_about_1 img{
  max-width: 100%;
	max-height: 100%;
}
.atp_2_2d1i{
  background-image: url('../assets/about1111.jpg');
  background-size: 100%;
  background-position: center center;
}
.atp_2_2d12{
  background: url('../assets/about2222.jpg') no-repeat center center;
  background-size: 100%;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue